// import { dbDate } from '../utils/date';
// import { useCallback, useEffect, useState } from 'react';
// import { useAuth } from '../utils/token';
import { useQuery } from './hooks';
import { schema } from './schema';
// import { useAuth } from '../teal-react/utils/token';

export const useUsersQuery = () => {
  return useQuery(`query Users{
    user{
      ${schema['user']}
    }
  }`);
};

export const useUserQuery = (id: number) => {
  return useQuery(
    `query Users($where: String){
      user(where: $where){
        ${schema['user']}
      }
    }`,
    {
      variables: {
        where: JSON.stringify({ id }),
      },
    }
  );
};

export const useProductList = () => {
  return useQuery(`query productList {
      productList {
        ${schema['productList']}
      }
    }`);
};

export const useQc = (id: number) => {
  return useQuery(
    `query useQc($where: String) {
      qc(where: $where) {
        id
        date
        amount
        status
        created_at
        created_by
        tested_at
        tested_by
        approved_at
        approved_by
        unit: unit_id_unit {
          name
        }
        product: product_id_product { id name code }
        qc_code
      }
    }`,
    {
      variables: {
        where: JSON.stringify({ id }),
      },
    }
  );
};

export const useProductQc = (product_id: number) => {
  return useQuery(
    `query useProductQc($where: String) {
      qc(where: $where, order: "date desc") {
        id
        date
        amount
        status
        unit: unit_id_unit {
          name
        }
        qc_code
      }
    }`,
    {
      variables: {
        where: JSON.stringify({ product_id }),
      },
    }
  );
};

export const useQcWithBatch = (qc_id: number) => {
  return useQuery(
    `query useBatch($where: String) {
        qc (where: $where){
          id
          amount
          date
          qc_code
          status
          unit_id
          unit: unit_id_unit {
            id
            name
          }
          product: product_id_product {
            id
            name
            shortname
            code
          }
          batch {
            id
            notes
            materials: batch_material(order: "ordinal") {
              id
              material
              amount
              remark
              unit: unit_id_unit {
                id
                name
              }
            }
          }
        }
      }`,
    {
      variables: {
        where: JSON.stringify({ id: qc_id }),
      },
    }
  );
};

export const useBatchMaterials = (batch_id: number) => {
  return useQuery(
    `query BatchMaterialsEditor($where: String) {
        batch(where: $where) {
          id
          materials: batch_material {
            id
            amount
            material
            ordinal
            remark
            unit_id
            unit: unit_id_unit {
              id
              name
            }
          }
        }
      }`,
    {
      variables: {
        where: JSON.stringify({ id: batch_id }),
      },
    }
  );
};

export const useQcSearch = (qc_code: string, limit: number = 10) => {
  return useQuery(
    `query qcSearch($where: String, $limit: Int){
        qc(where: $where, limit: $limit, order: "date desc"){
          id
          qc_code
          amount
          date
          status
          product: product_id_product {
            id
            name
            code
          }
        }
      }
    `,
    {
      lazy: true,
      variables: {
        limit,
        where: JSON.stringify({ qc_code: { like: qc_code } }),
      },
    }
  );
};

export const useQcTestSummary = (qc_id: number) => {
  return useQuery(
    `query TestViewer($qc_id: Int, $where: String){
        qcTestSummary(qc_id: $qc_id){
          qc_test_id
          name
          coa
          ordinal
          parameter
          result
        }
        qc(where: $where){
          id
          qc_code
          amount
          date
          status
          product: product_id_product {
            id
            name
            code
            shelflife
          }
         unit: unit_id_unit {
            id
            name
          }
        }
      }`,
    {
      variables: { qc_id, where: JSON.stringify({ id: qc_id }) },
    }
  );
};

export const useUnitLookup = () => {
  return useQuery(`query unitlookup { unit { id, name }}`);
};

export const useMaterialsLookup = () => {
  return useQuery(
    `query materiallookup { material(order: "name") { id name }}`
  );
};

export const useFormulaList = (product_id: number) => {
  return useQuery(
    `query FormulasList($where: String) {
        formula(where: $where) {
          id
          name
          amount
          unit_id
          unit: unit_id_unit {
            name
          }
          materials: formula_material(order: "ordinal") {
            id
            material: material_id_material {
              id
              name
              price
              density
            }
            ordinal
            amount
            weight_percentage
            remark
            unit_id
            unit: unit_id_unit {
              name
            }
          }
        }
      }`,
    {
      variables: { where: JSON.stringify({ product_id }) },
    }
  );
};

export const useMaterialsEditor = (formula_id: number) => {
  return useQuery(
    `query MaterialsEditor($where: String) {
        materials: formula_material(where: $where, order: "ordinal") {
          id
          amount
          remark
          ordinal
          weight_percentage
          unit_id
          unit: unit_id_unit {
            id
            name
          }
          material_id
          material: material_id_material {
            id
            name
            price
            density
          }
        }
      }`,
    {
      variables: {
        where: JSON.stringify({ formula_id }),
      },
    }
  );
};

export const useTestingSetup = (product_id: number) => {
  return useQuery(`query TestingSetup {
    query
  }`);
};

export const useMaterials = () => {
  return useQuery(
    `query Materials($whereNoDel: String) {
      material(order: "name") {
        id name price density

        formulas: formula_material {
          formula: formula_id_formula (where: $whereNoDel) {
            id
            name
            product: product_id_product (where: $whereNoDel) {
              id
              name
            }
          }
        }
      }
    }`,
    {
      variables: {
        whereNoDel: JSON.stringify({ deleted_at: null }),
      },
    }
  );
};
